import { MsUser } from "@/types/msuser";
import { api } from "..";
import { buildQueryString } from "./utils";
import { ResultOk } from "@/types/resultok";

export const userApi = api.injectEndpoints({
  endpoints: (build) => ({
    // 获取我的私信左半部分列表
    getMsUserByToId: build.query<MsUser[], { user_id: string }>({
      query: (params) => `/msuser${buildQueryString(params)}`,
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
    }),
    //获取我的私信右半部分对话内容列表
    GetMSUserAll: build.query<MsUser[], { user_id: string; from_id: string }>({
      query: (params) => `/msuser${buildQueryString(params)}`,
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
      providesTags: ['MsuserChat'],
    }),
    //创建私信
    createMsUser: build.mutation<ResultOk, { from_id: string; to_id: string; content: string }>({
      query: (body) => ({
        url: "/msuser/create",
        method: "POST",
        body,
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
      invalidatesTags: ["MsuserChat"],
    }),
  }),
});

export const { useGetMSUserAllQuery, useGetMsUserByToIdQuery, useLazyGetMSUserAllQuery, useLazyGetMsUserByToIdQuery, useCreateMsUserMutation } = userApi;
